import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from '../../../../../react/features/base/dialog/actions';
import { IconNoiseSuppressionOff, IconNoiseSuppressionOn } from '../../../../../react/features/base/icons/svg';
import Label from '../../../../../react/features/base/label/components/web/Label';
import { hideTooltip, showTooltip } from '../../../../../react/features/base/tooltip/actions';
import Tooltip from '../../../../../react/features/base/tooltip/components/Tooltip';
import { isNoiseSuppressionEnabled } from '../../../../../react/features/noise-suppression/functions';
import SettingsDialog from '../../../../../react/features/settings/components/web/SettingsDialog';
import { iAmVisitor } from '../../../../../react/features/visitors/functions';
import { ADVANCED_TAB_NAME } from '../../../advanced-tab/constants';
const NoiseSuppressionLabel = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // @ts-ignore
    const { iAmRecorder } = useSelector(state => state['features/base/config']);
    const isVisitor = useSelector(iAmVisitor);
    const isNoiseSuppression = useSelector(isNoiseSuppressionEnabled);
    const icon = isNoiseSuppression ? IconNoiseSuppressionOn : IconNoiseSuppressionOff;
    const content = isNoiseSuppression
        ? t('customNoiseSuppression.noiseSuppressionLabel.tooltipOn')
        : t('customNoiseSuppression.noiseSuppressionLabel.tooltipOff');
    // We should set new tooltip content to the store to re-render tooltip immediately
    useEffect(() => {
        dispatch(showTooltip(content));
    }, [content]);
    const onClick = () => {
        dispatch(hideTooltip(content));
        dispatch(openDialog(SettingsDialog, {
            defaultTab: ADVANCED_TAB_NAME,
            isDisplayedOnWelcomePage: false
        }));
    };
    // @ts-ignore
    if (iAmRecorder || isVisitor || APP.wildix.wizy) {
        return null;
    }
    return (React.createElement(Tooltip, { content: content, position: 'bottom' },
        React.createElement(Label, { accessibilityText: t('customNoiseSuppression.noiseSuppressionLabel.accessibilityLabel'), icon: icon, id: 'noiseSuppressionLabel', onClick: onClick })));
};
export default NoiseSuppressionLabel;
